import { render, staticRenderFns } from "./FavoriteGoods.vue?vue&type=template&id=00e9cf82&scoped=true&"
import script from "./FavoriteGoods.vue?vue&type=script&lang=js&"
export * from "./FavoriteGoods.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteGoods.vue?vue&type=style&index=0&id=00e9cf82&lang=scss&scoped=true&"
import style1 from "./FavoriteGoods.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e9cf82",
  null
  
)

export default component.exports